import { coerceMoneyValue, Money } from '../common';
import { AccountStat } from './AccountStat';

const coerceMoneyOrZero = (value: unknown, fallbackCurrencyCode: string): Money | null => {
  const money = coerceMoneyValue(value);
  if (money) {
    return money;
  }

  if (!value || typeof value !== 'object') {
    return null;
  }

  const raw = value as Record<string, unknown>;
  if (raw.amount !== null && raw.amount !== undefined) {
    return null;
  }

  const currencyCode =
    typeof raw.currencyCode === 'string' ? raw.currencyCode : fallbackCurrencyCode;

  return new Money(0, currencyCode);
};

export function normalizeAccountStat(data: unknown): AccountStat | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const raw = data as Record<string, unknown>;
  const invested = coerceMoneyValue(raw.invested);
  const returned = coerceMoneyValue(raw.returned);

  if (!invested || !returned) {
    return null;
  }

  const recoveryForecast = coerceMoneyOrZero(raw.recoveryForecast, invested.currencyCode);

  if (!recoveryForecast) {
    return null;
  }

  if (typeof raw.factRoi !== 'number' || typeof raw.factIrr !== 'number') {
    return null;
  }

  return {
    invested,
    returned,
    recoveryForecast,
    factRoi: raw.factRoi,
    factIrr: raw.factIrr,
  };
}
